export default __webpack_public_path__ + "images/6d2180c1ead600eb9feda24a10a4bf70.png";